
import React, { useState, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import Carousel from "./Carousel";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext.jsx";
import { useCampaign } from '../../Context/CampaignContext.jsx';

const Wallet = ({ activeTab, point, studentReferral, referral, setReferral, balance, lastTransaction }) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [program, setProgram] = useState("MBA");
  const [success, setSuccess] = useState("");
  const [countries, setCountries] = useState([]);
  const [proxycountry, setProxycountry] = useState("India");
  const [transaction, setTransaction] = useState([]);
  const [error, setError] = useState('');
  const [validatephone, setValidatePhone] = useState("");
  const [validatemail, setValidateEmail] = useState("");
  const { token } = useAuth();
  const { campaign, source, medium, saveCampaignData } = useCampaign();
  const [reedemessage, setReedemessage] = useState("");
  const [disabledbutton, setDisablebutton] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisablebutton(true);
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/referrals`,
        {
          candidate_name: firstname + " " + lastname,
          candidate_email: email,
          candidate_phone: phone,
          candidate_country: proxycountry,
          candidate_program: program,
          campaign: campaign,
          utm_source: source,
          medium: medium,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (resp.status === 201) {
        setSuccess(resp.data.message);
        setTimeout(() => {
          setSuccess("");
          setFirstname("");
          setLastname("");
          setEmail("");
          setPhone("");
          setProxycountry("India");
          setProgram("MBA");
          setReferral(false);
          studentReferral();
          setDisablebutton(false);
          saveCampaignData("", "", "");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      setError(error.response?.data?.message || "Something went wrong");
      if (error.response?.data?.errors) {
        setValidatePhone(error.response.data.errors[0].isEmail);
        setValidateEmail(error.response.data.errors[0].isPhoneNumber);
      }
      setTimeout(() => {
        setError("");
        setValidatePhone("");
        setValidateEmail("");
        setDisablebutton(false);
      }, 3000);
    }
  };

  const redeemPointApi = async () => {
    if (balance.balance > 0) {
      try {
        const resp = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/points/redeem`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (resp.status === 200) {
          let ssoToken = resp.data.redirectUrl.ssoToken;
          window.open(`${process.env.REACT_APP_XOXODAY_STOREFRONT_SSO_REDIRECT_ENDPOINT_URL}/${ssoToken}`, '_blank');
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setReedemessage("Points must be greater than zero to redeem rewards.");
      setTimeout(() => setReedemessage(""), 3000);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.get('https://restcountries.com/v3.1/all?fields=name,flags');
      let countryNames = response.data.map(country => country.name.common);
      setCountries(countryNames.sort());
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAllTransaction = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/points/transactions`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        setTransaction(response.data.data.transactions);
      }
    } catch (error) {
      console.log(error);
    }
  }, [token]);

  useEffect(() => {
    fetchAllTransaction();
    fetchCountries();
  }, [fetchAllTransaction]);

  const cancelFuntion = () => {
    setProxycountry('India');
    setProgram("MBA");
    setFirstname("");
    setLastname("");
    setEmail("");
    setPhone("");
    setReferral(false);
  };

  const formatDate = (utcTimestamp) => {
    if (!utcTimestamp) return "N/A";
    const date = new Date(utcTimestamp);
    return date.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (activeTab !== 2) return null;

  return (
    <div className="animate-fadeIn space-y-10 pb-10">
      {/* Dashboard Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Main Balance Card */}
        <div className="bg-gradient-to-br from-[#004f6b] to-[#003e54] rounded-xl p-8 text-white relative overflow-hidden group col-span-1 md:col-span-2 lg:col-span-1">
          <div className="hidden sm:block absolute top-0 right-0 p-8 opacity-10 group-hover:scale-110 transition-transform duration-500 pointer-events-none">
            <svg className="w-32 h-32" fill="currentColor" viewBox="0 0 24 24"><path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" /></svg>
          </div>
          <div className="relative z-10 flex flex-col justify-between h-full">
            <div>
              <h3 className="text-xs font-medium opacity-70">Current Balance</h3>
              <p className="text-4xl font-bold tracking-tight mt-2">{balance.balance || '0.00'} <span className="text-lg font-normal opacity-60 ml-1">pts</span></p>
            </div>
            <div className="mt-10 flex gap-3">
              <button
                onClick={() => setReferral(true)}
                className="flex-1 py-3 bg-white text-[#004f6b] rounded-xl font-semibold text-sm hover:bg-gray-100 transition-all active:scale-95 shadow-lg"
              >
                Add Referral
              </button>
            </div>
          </div>
        </div>

        {/* Secondary Stats */}
        <div className="bg-white rounded-xl p-8 border border-gray-100 shadow-sm flex flex-col justify-between relative overflow-hidden group">
          {/* <div className="absolute -right-4 -top-4 w-24 h-24 bg-amber-50 rounded-full group-hover:scale-150 transition-transform duration-700 opacity-50"></div> */}
          <div>
            <p className="text-xs font-medium text-gray-500">Today's Limit</p>
            <p className="text-3xl font-bold text-amber-500 mt-2">{point.balance || '0.00'} <span className="text-sm text-gray-400 font-normal ml-1">pts remaining</span></p>
          </div>
          <div className="mt-4 pt-4 border-t border-gray-50">
            <p className="text-xs font-normal text-gray-400">Daily limit resets at midnight IST</p>
          </div>
        </div>

        <div className="bg-white rounded-xl p-8 border border-gray-100 shadow-sm flex flex-col justify-between relative overflow-hidden group">
          {/* <div className="absolute -right-4 -top-4 w-24 h-24 bg-green-50 rounded-full group-hover:scale-150 transition-transform duration-700 opacity-50"></div> */}
          <div>
            <p className="text-xs font-medium text-gray-500">Total Redeemed</p>
            <p className="text-3xl font-bold text-green-500 mt-2">{lastTransaction?.total_points_redeemed || '0.00'} <span className="text-sm text-gray-400 font-normal ml-1">pts</span></p>
          </div>
          <div className="mt-4 pt-4 border-t border-gray-50">
            <p className="text-xs font-normal text-gray-400">Lifetime rewards earned</p>
          </div>
        </div>
      </div>

      {reedemessage && (
        <div className="bg-red-50 text-red-600 px-6 py-4 rounded-xl border border-red-100 text-sm font-medium animate-fadeIn text-center">
          {reedemessage}
        </div>
      )}

      {/* Transactions Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mt-8">
        <div className="px-8 py-6 border-b border-gray-100 bg-gray-50/10 flex justify-between items-center">
          <h3 className="text-base font-semibold text-gray-800">Wallet Transactions</h3>
          <div className="h-2 w-2 rounded-full animate-pulse"></div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-100">
                <th className="px-8 py-4 text-xs font-semibold text-gray-600 text-center w-20">Sr. No</th>
                <th className="px-8 py-4 text-xs font-semibold text-gray-600">Transaction ID</th>
                <th className="px-8 py-4 text-xs font-semibold text-gray-600">Activity Type</th>
                <th className="px-8 py-4 text-xs font-semibold text-gray-600">Amount</th>
                <th className="px-8 py-4 text-xs font-semibold text-gray-600 text-right pr-12">Timestamp</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {transaction.length > 0 ? (
                transaction.map((item, index) => (
                  <tr key={index} className="group hover:bg-gray-50/50 transition-colors">
                    <td className="px-8 py-6 text-sm text-gray-300 font-mono text-center">#{index + 1}</td>
                    <td className="px-8 py-6">
                      <span className="text-xs font-mono font-medium text-gray-500  px-2 py-1">
                        {item.id}
                      </span>
                    </td>
                    <td className="px-8 py-6">
                      <span className={`inline-flex px-3 py-1 rounded-lg text-xs font-medium border ${item.transaction_type === 'credited' ? 'bg-green-50 text-green-700 border-green-100' : 'bg-red-50 text-red-700 border-red-100'
                        }`}>
                        {item.transaction_type}
                      </span>
                    </td>
                    <td className="px-8 py-6">
                      <span className={`text-sm font-semibold ${item.transaction_type === 'credited' ? 'text-green-600' : 'text-red-600'}`}>
                        {item.transaction_type === 'credited' ? '+' : '-'}{item.points} Pts
                      </span>
                    </td>
                    <td className="px-8 py-6 text-right pr-12">
                      <span className="text-xs font-normal text-gray-500">{formatDate(item.updated_at)}</span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="px-8 py-20 text-center text-gray-400 font-normal">No wallet activity recorded yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm overflow-hidden">
        <Carousel />
      </div>

      {/* Popup Form Modal */}
      {referral && createPortal(
        <div className="fixed inset-0 z-[9999] flex items-start sm:items-center justify-center p-4 overflow-y-auto">
          <div
            className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm animate-fadeIn"
            onClick={cancelFuntion}
          ></div>
          <div className="relative bg-white rounded-xl shadow-xl w-full max-w-4xl my-auto max-h-[calc(100vh-2rem)] overflow-y-auto animate-zoomIn border border-gray-100 overflow-x-hidden">
            <div className="sticky top-0 z-10 bg-white/95 backdrop-blur-md px-6 sm:px-12 py-6 sm:py-8 border-b border-gray-100 flex justify-between items-center">
              <div className="flex items-start flex-col">
                <h2 className="text-2xl font-bold text-gray-900 tracking-tight">Add New Referral</h2>
                <p className="text-sm text-gray-500 font-normal mt-1">Earn more rewards by referring qualified candidates.</p>
              </div>
              <button
                onClick={cancelFuntion}
                className="p-3 hover:bg-gray-100 rounded-xl transition-colors text-gray-400 hover:text-gray-900"
              >
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-6 md:p-8 lg:p-12 space-y-4 md:space-y-6 lg:space-y-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5 lg:gap-8">
                {/* First Name */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">First Name</label>
                  <input
                    type="text"
                    placeholder="Ex: John"
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none transition-all font-normal text-gray-800"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                    required
                  />
                </div>

                {/* Last Name */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Last Name</label>
                  <input
                    type="text"
                    placeholder="Ex: Doe"
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none transition-all font-normal text-gray-800"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    required
                  />
                </div>

                {/* Email */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Email Address</label>
                  <input
                    type="email"
                    placeholder="john.doe@example.com"
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none transition-all font-normal text-gray-800"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    required
                  />
                </div>

                {/* Country */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Country</label>
                  <select
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none appearance-none transition-all font-normal text-gray-800 cursor-pointer"
                    value={proxycountry}
                    onChange={(e) => setProxycountry(e.target.value)}
                    required
                  >
                    <option value="" disabled>Select country</option>
                    {countries.map((country) => (
                      <option key={country} value={country}>{country}</option>
                    ))}
                  </select>
                </div>

                {/* Phone Number */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Phone Number</label>
                  <div className="relative group">
                    <input
                      type="text"
                      placeholder="Ex: 9876543210"
                      className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none transition-all font-normal text-gray-800"
                      value={phone}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,10}$/.test(value)) setPhone(value);
                      }}
                      required
                    />
                    <div className="absolute inset-y-0 right-5 flex items-center pointer-events-none opacity-40 text-xs font-medium">10 Digits</div>
                  </div>
                </div>

                {/* Program */}
                <div className="space-y-1.5 lg:space-y-2 flex flex-col">
                  <label className="text-xs font-medium text-gray-500 text-start pl-1">Interested Program</label>
                  <select
                    className="w-full px-4 py-3 lg:px-6 lg:py-4 text-sm lg:text-base bg-gray-50 border border-gray-100 rounded-xl focus:ring-4 focus:ring-[#004f6b]/5 focus:border-[#004f6b] outline-none appearance-none transition-all font-normal text-gray-800 cursor-pointer"
                    value={program}
                    onChange={(e) => setProgram(e.target.value)}
                    required
                  >
                    {["MBA", "MCA", "M.Com", "MA", "BBA", "BCA", "B.Com"].map(p => (
                      <option key={p} value={p}>{p}</option>
                    ))}
                  </select>
                </div>
              </div>

              {error && <div className="bg-red-50 text-red-600 px-6 py-4 rounded-xl border border-red-100 text-sm font-medium animate-shake">{error}</div>}
              {(validatephone || validatemail) && (
                <div className="bg-red-50 text-red-600 px-6 py-4 rounded-xl border border-red-100 text-xs font-medium space-y-1">
                  {validatephone && <p>• {validatephone}</p>}
                  {validatemail && <p>• {validatemail}</p>}
                </div>
              )}
              {success && <div className="bg-green-50 text-green-700 px-6 py-4 rounded-xl border border-green-100 text-sm font-medium flex items-center gap-3 animate-bounce">✓ {success}</div>}

              <div className="flex flex-col sm:flex-row gap-4 pt-4">

                <button
                  type="button"
                  onClick={cancelFuntion}
                  className="flex-1 py-3 lg:py-5 border-2 border-gray-100 bg-gray-100 text-gray-500 hover:text-gray-800 hover:bg-gray-50 rounded-xl font-semibold text-sm transition-all active:scale-95"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={disabledbutton}
                  className={`flex-[2] py-3 lg:py-5 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-semibold text-sm transition-all  flex items-center justify-center gap-4 active:scale-95 ${disabledbutton ? 'opacity-50 grayscale' : ''}`}
                >
                  {disabledbutton ? 'Processing...' : 'Save'}
                  {!disabledbutton && <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>}
                </button>
              </div>
            </form>
          </div>
        </div>,
        document.body
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes zoomIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
        .animate-zoomIn {
          animation: zoomIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
        .animate-shake {
          animation: shake 0.2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Wallet;
